/**
 * Erreurs liées à l'IA et aux traductions
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const MISTRAL_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.MISTRAL_FILE_UPLOAD_FAILED]: {
        messageKey: 'an-error-occurred-with-the-ai',
        severity: 'error',
    },
    [ERROR_CODES.MISTRAL_FILE_UPLOAD_SERVER_ERROR]: {
        messageKey: 'the-connection-with-the-ai-is-temporarily-interrupted-please-try-again-later',
        severity: 'error',
    },
    [ERROR_CODES.MISTRAL_FILE_URL_FAILED]: {
        messageKey: 'an-error-occurred-with-the-ai',
        severity: 'error',
    },
};
